import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const Poll = (props) => (<Svg viewBox="0 0 16 16" fill="none" accessibilityRole="image" {...props}>
    <Path d="M3.80013 13.5999V9.3999" stroke={props.stroke ?? '#393360'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M12.1999 13.6001V6.6001" stroke={props.stroke ?? '#393360'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M8 13.5999V2.3999" stroke={props.stroke ?? '#393360'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default Poll;
